import { createGlobalStyle } from "styled-components/macro";
import { mediaQueries } from "./media.js";

const GlobalStyle = createGlobalStyle`
  /* normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */
  /* stylelint-disable */
  html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}
  /* stylelint-enable */

  /* stylelint-disable no-duplicate-selectors */
  html {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: scroll; /* keeps page centred in all browsers regardless of content height */
    -ms-overflow-style: scrollbar; /* force the scrollbar to always display in IE10/IE11 – prevents page jumping left/right */
    box-sizing: border-box;

    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-family: var(--juno-font-family-body);

    font-size: 1em;
    line-height: 1.5em;
    font-weight: var(--juno-font-weight-light);
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  * {
    color: inherit;
    font-family: inherit;
    line-height: inherit
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    padding: 0;

    height: 100%;
    color: var(--juno-color-text);
    background-color: var(--juno-color-body-background);
  }

  #root {
    height: 100%;
  }

  /* Text styles */
  p{
    font-size: var(--juno-font-size-body-sm);
    line-height: 1.5;
    margin-bottom: 1em;
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-body-md);
    }
  }

  h1 {
    font-size: var(--juno-font-size-h1-sm);
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h1-md);
    }
  }

  h2 {
    font-size: var(--juno-font-size-h2-sm);
    margin-left: -0.02em;
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h2-md);
    }
  }

  h3 {
    font-size: var(--juno-font-size-h3-sm);
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h3-md);
    }
  }

  h4 {
    font-size: var(--juno-font-size-h4-sm);
    ${mediaQueries.md} {
      font-size: var(--juno-font-size-h4-md);
    }
  }

  /* Links */
  a {
    text-decoration: none;
    transition: color 200ms;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.3);
  }

  a:link {
    color: var(--juno-color-link);
  }

  a:visited {
    color: var(--juno-color-link-visited);
  }

  a:hover {
    color: var(--juno-color-link-hover);
    border-bottom: 1px solid;
  }

  a:active {
    color: var(--juno-color-link-active);
    border-bottom: 1px solid;
  }

  a:focus-visible {
    color: var(--juno-color-link);
    outline: var(--juno-focus-outline-width) solid var(--juno-color-focus);
    outline-offset: var(--juno-focus-outline-offset);
    border-bottom: 1px solid;
  }
  /* stylelint-enable no-duplicate-selectors */

  strong {
    font-weight: var(--juno-font-weight-bold);
  }
`;

export default GlobalStyle;
